// BMI formula and WHO adult classification, mirrored from the backend
// (BmiMeasurement::calculate / categoryFor), which stays authoritative for saved values.

export const BMI_CATEGORIES = Object.freeze({
  underweight: { label: "Insuffisance pondérale", range: "< 18,5", color: "#3b82f6", background: "#dbeafe" },
  normal: { label: "Corpulence normale", range: "18,5 – 24,9", color: "#16a34a", background: "#dcfce7" },
  overweight: { label: "Surpoids", range: "25 – 29,9", color: "#ca8a04", background: "#fef9c3" },
  obese: { label: "Obésité", range: "≥ 30", color: "#dc2626", background: "#fee2e2" },
});

export const ADULT_AGE = 18;

/** BMI (kg/m²) rounded to one decimal, or null when an input is missing or not positive. */
export function calculateBmi(heightCm, weightKg) {
  const height = Number(heightCm) / 100;
  const weight = Number(weightKg);
  if (!(height > 0) || !(weight > 0)) return null;
  return Math.round((weight / (height * height)) * 10) / 10;
}

export function bmiCategory(bmi) {
  if (bmi === null || bmi === undefined || Number.isNaN(Number(bmi))) return null;
  if (bmi < 18.5) return "underweight";
  if (bmi < 25) return "normal";
  if (bmi < 30) return "overweight";
  return "obese";
}

/** Position of a BMI on a 15–35 gauge, in percent. */
export function gaugePosition(bmi) {
  return Math.max(0, Math.min(100, ((Number(bmi) - 15) / (35 - 15)) * 100));
}

export const formatBmi = (value) => (value === null || value === undefined ? "—" : Number(value).toLocaleString("fr-FR", { minimumFractionDigits: 1, maximumFractionDigits: 1 }));
